export default __webpack_public_path__ + "static/media/publish.a96ebd2f.svg";